import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getAssetFeatureOptionListByFeatureIdSaga = createAction(
  "GET_ASSET_FEATURE_OPTION_BY_BRAND_ID",
  ({
    payload,
    params,
    id,
  }: SagaActionParams<Type.AssetFeatureOptionDto[]>) => ({
    payload,
    url: "/api/picklistoptions/getbyfeatureid/" + id + (params ? params : ""),
  })
);
export const getAssetFeatureOptionDetailsSaga = createAction(
  "GET_ASSET_FEATURE_OPTION_DETAILS",
  ({ payload, id }: SagaActionParams<Type.AssetFeatureOptionDetailDto>) => ({
    payload,
    url: "/api/admin/picklistoptions/" + id,
  })
);
export const createAssetFeatureOptionSaga = createAction(
  "CREATE_ASSET_FEATURE_OPTION",
  ({ payload, body }: SagaActionParams<Type.AssetFeatureOptionDto>) => ({
    payload,
    url: "/api/admin/picklistoptions",
    body,
  })
);
export const updateAssetFeatureOptionSaga = createAction(
  "UPDATE_ASSET_FEATURE_OPTION",
  ({ payload, id, body }: SagaActionParams<Type.AssetFeatureOptionDto>) => ({
    payload,
    url: "/api/admin/picklistoptions/" + id,
    body,
  })
);
export const deleteAssetFeatureOptionSaga = createAction(
  "DELETE_ASSET_FEATURE_OPTION",
  ({ payload, id }: SagaActionParams<Type.AssetFeatureOptionDto>) => ({
    payload,
    url: "/api/admin/picklistoptions/" + id,
  })
);

const assetfeatureoptionsSaga = [
  takeLatest<any>(
    getAssetFeatureOptionListByFeatureIdSaga.toString(),
    (payload: SagaGenericParams<Type.AssetFeatureOptionDto[]>) =>
      getSaga<Type.AssetFeatureOptionDto[]>(payload)
  ),
  takeLatest<any>(
    getAssetFeatureOptionDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.AssetFeatureOptionDetailDto>) =>
      getSaga<Type.AssetFeatureOptionDetailDto>(payload)
  ),
  takeLatest<any>(
    createAssetFeatureOptionSaga.toString(),
    (payload: SagaGenericParams<Type.AssetFeatureOptionDto>) =>
      postSaga<Type.AssetFeatureOptionDto>(payload)
  ),
  takeLatest<any>(
    updateAssetFeatureOptionSaga.toString(),
    (payload: SagaGenericParams<Type.AssetFeatureOptionDto>) =>
      putSaga<Type.AssetFeatureOptionDto>(payload)
  ),
  takeLatest<any>(
    deleteAssetFeatureOptionSaga.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.AssetFeatureOptionDto>(payload)
  ),
];

export default assetfeatureoptionsSaga;
